
<template>
    <Card>
        <template slot="title">
            <Breadcrumb>
                <BreadcrumbItem to="/splitList">仓库信息</BreadcrumbItem>
                <BreadcrumbItem>批量维护仓库商品拆分比例</BreadcrumbItem>
            </Breadcrumb>
        </template>
        <template slot="extra">
            <a href="javascript:;" @click="downloadFile()">
                <Icon type="md-download" />
                下载模板
            </a>
            <router-link to="/splitList">返回</router-link>
        </template>
         <Form 
         :style="{width:'400px',margin:'0 auto'}"
         ref="formValidate" 
         :model="formInline" 
         :rules="ruleValidate" 
         :label-width="100">
                <FormItem label="文件上传" prop="url">
                    <Upload 
                    ref="upload"
                    :show-upload-list="false"
                    :action="uploadUrl"
                    :data="uploadPram"
                    :before-upload="beforeUpload"
                    :on-success="onSuccess"
                    :on-error="onError"
                    :max-size="20480000"
                    :headers='{"token": $sessionToken()}'
                    >
                        <Button icon="ios-cloud-upload-outline" :loading="uploading">{{fileName}}</Button>
                    </Upload>
                </FormItem>
            <FormItem>
                <Button type="primary" @click="submit()">提交</Button>
                <Button style="margin-left: 8px" @click="reset()">重置</Button>
            </FormItem>
        </Form>
    </Card>
</template>
<script>
    import axios from "axios";
    export default {
        data () {
            return {
                fileName:'上传Excel',
                uploadUrl:'',
                formInline: {
                    fileId:'',
                    url:''
                },
                uploadPram:{
                    fileType: 'WMS_TEMPLATE'
                },
                uploading:false,
                ruleValidate: {
                    url: [
                        { required: true, message: 'Excel不能为空', trigger: 'change' }
                    ],
                },
                templatePath:'https://eln-public.oss-cn-shanghai.aliyuncs.com/dev/ead8ebd1-bad6-4dae-bc04-55a4b268c17a.xlsx',
            }
        },
        created(){
          this.uploadUrl = axios.defaults.baseURL + 'base/template/uploadFile';
          this.getTemplate();
        },
        methods:{
            getTemplate(){
                this.$api.templateFile({fileType:'WMS_ORDER_SPILT_TEMPLATE'}).then((res) => {
                    if(res.code == '200'){
                        this.templatePath = res.data;
                    }
                });
            },
            beforeUpload(d){
                let types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel'];
                if(types.indexOf(d.type) == -1){
                    this.$Message.error('请上传Excel文件');
                    return false;
                }
                this.uploading = true;
                this.fileName = d.name;
            },
            onSuccess(response, file, fileList){
                this.uploading = false;
                if(response.code=='200'){
                    this.formInline.fileId = response.data.fileId;
                    this.formInline.url = response.data.url;
                }else{
                    this.$Message.error(response.message);
                }
            },
            onError(){
                this.fileName = '上传Excel';
                this.formInline.fileId = '';
                this.formInline.url = '';
                this.uploading = false;
                this.$Message.error('上传失败');
            },
            downloadFile(){
                let url = this.templatePath;
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                    } catch (e) {
                        this.$Message.error('下载异常！');
                    }
            },
            submit(){
                let data = this.formInline;
                if(!data.url){
                    this.$Message.error('请先上传Excel');
                    return
                }
                this.$api.splitImport(data).then((res) => {
                    if(res.code == '200'){
                        this.fileName = '上传Excel';
                        this.$Message.success(res.message);
                    }
                });
            },
            reset(){
                this.fileName = '上传Excel';
                this.formInline.fileId = '';
                this.formInline.url = '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/warehouse/splitImport.vue